'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoScreenFull = function GoScreenFull(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.5 30h25v-20h-25v20z m5-15h15v10h-15v-10z m-7.5-7.5h7.5v-2.5h-10v10h2.5v-7.5z m0 17.5h-2.5v10h10v-2.5h-7.5v-7.5z m22.5-20v2.5h7.5v7.5h2.5v-10h-10z m7.5 27.5h-7.5v2.5h10v-10h-2.5v7.5z' })
        )
    );
};

exports.default = GoScreenFull;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/screen-full.js
// module id = 1771
// module chunks = 0